import React from 'react';
import { sceneSlice } from '../../store/reducers/SceneReducer';
import { useAppDispatch } from '../../store/store';
import { campItemsArr } from '../../tempDB';
import CampAllies from './CampAllies/CampAllies';
import CampContentItem from './CampContentItem';

const CampContent = () => {
    const dispatch = useAppDispatch()
    const { setScene } = sceneSlice.actions

    const handleClick = (id: string) => {
        switch (id) {
            case 'allies':
                return dispatch(setScene('campAllies'))
            case 'character':
                return dispatch(setScene('campCharacterUpgrade'))
            case 'equipment':
                return dispatch(setScene('campEquipmentUpgrade'))
            default:
                return dispatch(setScene('camp'))
        }
    }

    return (
        <div className="camp__content">
            {campItemsArr.map(item => {
                return (
                    <CampContentItem key={crypto.randomUUID()} item={item} handleClick={() => handleClick(item.id)} />
                )
            })}
        </div>
    );
};

export default CampContent;